import React from 'react';
import {FmlxIcon} from 'fmlx-common-ui';
import './MandatoryBadge.scss';

const MandatoryBadge = ({title, iconName, size, customColor, label, checkValue, className}) => {
  const showWarning = checkValue;

  return (
    <div className="mandatory-badge-container">
      {showWarning && (
        <div className={className}>
          <FmlxIcon name={iconName} size={size} customColor={customColor}/>
          <p className="warning-text">{label}</p>
        </div>
      )}
    </div>
  );
};

export default MandatoryBadge;
